var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8631 2.151C17.4463 1.72318 16.8294 1.5638 16.2541 1.73157L2.84032 5.63229C2.23341 5.8009 1.80323 6.28492 1.68735 6.89981C1.56897 7.5256 1.98247 8.32001 2.52269 8.6522L6.71691 11.23C7.14709 11.4943 7.70231 11.428 8.05829 11.069L12.8611 6.23627C13.1029 5.98461 13.503 5.98461 13.7448 6.23627C13.9866 6.47954 13.9866 6.8738 13.7448 7.12546L8.93365 11.959C8.57684 12.3172 8.51014 12.875 8.77275 13.3079L11.3355 17.5442C11.6356 18.0475 12.1525 18.3327 12.7194 18.3327C12.7861 18.3327 12.8611 18.3327 12.9278 18.3243C13.5781 18.2404 14.0949 17.7958 14.2867 17.1667L18.2633 3.77001C18.4384 3.19958 18.28 2.57882 17.8631 2.151Z",
    fill: "#ffffff",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWhite);
export default __webpack_public_path__ + "static/media/share_white.046b197c95812613dace264ec57db18f.svg";
export { ForwardRef as ReactComponent };